import { Component, OnInit } from '@angular/core';
import { IntercomService } from '@services';

@Component({
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent implements OnInit {
  constructor(private intercomService: IntercomService) {}

  ngOnInit() {}

  openSupport() {
    this.intercomService.show();
  }
}
